import React from 'react'

import { Box, Button, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { useForm } from 'modules/core/hooks/useForm'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import SettingsGroup from 'modules/security_settings/components/SettingsGroup'
import { useUpdateBecome } from 'modules/security_settings/pages/SecuritySettingsPage/BecomeSection/useUpdateBecome'
import { TypedSecuritySettingsSecuritySettingsPageFragment } from 'modules/security_settings/pages/SecuritySettingsPage/useCompanyConfig'

interface BecomeFormValues {
  staffBecomeEnabled: TypedSecuritySettingsSecuritySettingsPageFragment['staffBecomeEnabled']
}

interface Props {
  staffBecomeEnabled: TypedSecuritySettingsSecuritySettingsPageFragment['staffBecomeEnabled']
}

function BecomeForm({ staffBecomeEnabled }: Props) {
  const { updateBecome, loading: updating } = useUpdateBecome()

  const form = useForm<BecomeFormValues>({
    defaultValues: {
      staffBecomeEnabled,
    },
    onSubmit: async (data) => {
      const result = await updateBecome(data.staffBecomeEnabled)
      const handled = handleResult(result, (_formErrors) => {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('security_settings.become.staff_become_enabled.form.error_flash'),
          time: 60000, // 1 minute
        })
      })
      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })
        const staffBecomeEnabled = handled.data.companyConfig?.staffBecomeEnabled ?? false
        form.resetForm({ values: { staffBecomeEnabled } })
      }
      return handled
    },
  })

  function handleBecomeChange(nextToggled: boolean) {
    form.setFieldValue('staffBecomeEnabled', nextToggled)
  }

  return (
    <form onSubmit={form.handleSubmit}>
      <Box width="full" gap="s32">
        <SettingsGroup>
          <Box width="full" flexDirection="row" justifyContent="spaceBetween">
            <Text weight="semibold" size="300" color="grey1000">
              {i18n.t('security_settings.become.staff_become_enabled.form.enable_become.label')}
            </Text>
            <TogglerCheckbox
              value={staffBecomeEnabled}
              onChange={handleBecomeChange}
              disabled={updating}
            />
          </Box>
        </SettingsGroup>
        <Box width="full" flexDirection="rowReverse">
          <Button disabled={!form.dirty || updating} submit>
            {i18n.t('common.save_changes')}
          </Button>
        </Box>
      </Box>
    </form>
  )
}

export default React.memo(BecomeForm)
